/* eslint-disable react-refresh/only-export-components -- intentional: step exports a helper alongside the component */
import { useTranslation } from 'react-i18next';

import type { WizardState } from '../types';
import { PromptInIngleseHint } from '@/components/avatars/PromptInIngleseHint';

interface Props {
  state: WizardState;
  update: <K extends keyof WizardState>(k: K, v: WizardState[K]) => void;
}

const MAX_MOTION_CHARS = 300;

export function Step4MotionBrief({ state, update }: Props) {
  const { t } = useTranslation('avatars');
  const count = state.motionPrompt.length;
  return (
    <section className="flex flex-col gap-5">
      <header className="flex flex-col gap-1">
        <h1 className="text-xl font-bold text-fg">{t('editor.step4.title')}</h1>
        <p className="text-sm text-fg-muted">
          {t('editor.step4.intro')}
        </p>
      </header>

      <div className="flex flex-col gap-1.5">
        <label htmlFor="ed-motion" className="text-xs font-semibold uppercase text-fg-muted">
          {t('editor.step4.label')}
        </label>
        <textarea
          id="ed-motion"
          value={state.motionPrompt}
          onChange={e => update('motionPrompt', e.target.value.slice(0, MAX_MOTION_CHARS))}
          placeholder={t('editor.step4.placeholder')}
          className="min-h-[140px] rounded-xl bg-bg-secondary p-3 text-sm text-fg placeholder:text-fg-muted/60 focus:outline-none"
        />
        <PromptInIngleseHint />
        <p className="text-right text-[11px] text-fg-muted">{count} / {MAX_MOTION_CHARS}</p>
      </div>

      <div className="rounded-xl bg-bg-secondary p-3 text-xs leading-relaxed text-fg-muted">
        <p className="font-semibold text-fg">{t('common.tips')}</p>
        <ul className="mt-1 space-y-0.5">
          <li>• {t('editor.step4.tipAction')}</li>
          <li>• {t('editor.step4.tipAdverb')}</li>
          <li>• {t('editor.step4.tipLoop')}</li>
        </ul>
      </div>
    </section>
  );
}

export function step4Valid(state: WizardState): boolean {
  return state.motionPrompt.trim().length >= 3;
}
